module.exports = __webpack_public_path__ + "static/media/frequently_asked_questions.cbca9045.png";